import { MunicipioAPI } from "@/api/municipio.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Municipio } from "@/models/municipio";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const municipioApi = new MunicipioAPI();

const getAll = (): AxiosObservable<Municipio[]> => {
  return municipioApi.getAll();
};

const getAllSoa = (): AxiosObservable<Municipio[]> => {
  return municipioApi.getAllSoa();
};

const getAllMunicipiosParaSitPedidos = (): AxiosObservable<Municipio[]> => {
  return municipioApi.getAllMunicipiosParaSitPedidos()
};

export default {
  getAll,
  getAllSoa,
  getAllMunicipiosParaSitPedidos
};
